import React, { Component } from 'react';
import classnames from 'classnames';
import * as styles from './index.module.scss';

export class SideBarContainer extends Component {
  static propTypes = {};

  render() {
    const { children, ...other } = this.props;

    return (
      <div className={classnames('text-right', styles.sidebarContainer)} {...other}>
        <ul>{children}</ul>
      </div>
    );
  }
}

export default SideBarContainer;
